import { render, staticRenderFns } from "./ShowLead.vue?vue&type=template&id=f6d72710&scoped=true&"
import script from "./ShowLead.vue?vue&type=script&lang=js&"
export * from "./ShowLead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d72710",
  null
  
)

export default component.exports